import { REQUEST_LOGIN, REQUEST_LOGIN_FAILURE, REQUEST_LOGIN_SUCCESS } from "../constant/AuthenticationConstant";

const initialState = {
    loginState: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const loginReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case REQUEST_LOGIN:
            return {
                ...state,
                loginState: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_LOGIN_SUCCESS:
            return {
                ...state,
                loginState: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_LOGIN_FAILURE:
            return {
                ...state,
                loginState: {
                    data: [],
                    status: 'failure',
                    isLoading: false,
                },
            };
        default:
            return state;
    }
}
